"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataList = exports.DataItem = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const null_value_1 = __importDefault(require("./null-value"));
const DataListContainer = styled_components_1.default.div `
  border-top: 1px ${(props) => props.theme.colors.borderDefault} solid;
  border-bottom: 1px ${(props) => props.theme.colors.borderDefault} solid;

  ${(props) => props.condensed &&
    `
    border-top: 0;
    border-bottom: 0;
    padding-left: ${props.theme.spacing.none};
    padding-right: ${props.theme.spacing.none};
  `}
`;
const DataItemContainer = styled_components_1.default.div `
  color: ${(props) => props.theme.colors.textDark};
  padding-top: ${(props) => props.theme.spacing.s};
  padding-bottom: ${(props) => props.theme.spacing.s};

  display: flex;

  ${(props) => !props.condensed &&
    `
    &:not(:first-of-type) {
      border-top: 1px ${props.theme.colors.borderDefault} solid;
    }
  `}

  ${(props) => props.condensed &&
    `
    padding-top: ${props.theme.spacing.xs};
    padding-bottom: ${props.theme.spacing.xs};
  `}
`;
const Label = styled_components_1.default.span `
  color: ${(props) => props.theme.colors.textDefault};
  margin-right: ${(props) => props.theme.spacing[props.condensed ? 's' : 'm']};
  min-width: 170px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const DataItem = (_a) => {
    var { condensed, label, value = null } = _a, commonProps = __rest(_a, ["condensed", "label", "value"]);
    return (react_1.default.createElement(DataItemContainer, Object.assign({}, commonProps, { condensed: condensed }),
        react_1.default.createElement(Label, { condensed: condensed }, label),
        value || react_1.default.createElement(null_value_1.default, null)));
};
exports.DataItem = DataItem;
const DataList = (_a) => {
    var { condensed = false, dataItems } = _a, commonProps = __rest(_a, ["condensed", "dataItems"]);
    return (react_1.default.createElement(DataListContainer, Object.assign({}, commonProps, { condensed: condensed }), dataItems.map(({ label, value }) => (react_1.default.createElement(exports.DataItem, { key: `${label}-${value}`, condensed: condensed, value: value, label: label })))));
};
exports.DataList = DataList;
exports.default = exports.DataList;
